import React from 'react';
import TextWithImageSection from '../components/TextWithImageSection';
import { routes } from '../routes';
import impulseRefImage from '../assets/images/impulse/impulse-ref.png';
import Category from '../components/Category';
import Title from '../components/Title';
import Text from '../components/Text';
import SectionDetailsLink from '../components/SectionDetailsLink';
import Media from '../components/Media';

const ImpulseSection = () => (
    <TextWithImageSection
        text={(
            <>
                <Category>Stories</Category>
                <Title>Supporting Electric Bus Operations - IMPULSE project</Title>
                <Text>
                    <p>
                        The IMPULSE and IMPULSE+ projects, supported by EIT Urban Mobility and co-funded by the European
                        Union, were carried out to enhance realCity’s platform for electric bus operations. Pilots in
                        Lisbon and Istanbul allowed the validation of new methods for collecting, analysing, and
                        predicting vehicle and charger data. The solution was extended to support mixed e-bus fleets and
                        diverse hardware, bringing vehicles and charging infrastructure into one unified operational
                        environment. By participating in these projects, realCity aims to drive innovation and promote
                        greener urban mobility solutions.
                    </p>
                </Text>
                <SectionDetailsLink navigateTo={routes.impulseStory}>
                    Details
                </SectionDetailsLink>
            </>
        )}
        image={(
            <Media
                component="img"
                src={impulseRefImage}
                variant="left"
                alt="realCity Supporting Electric Bus Operations - IMPULSE project"
            />
        )}
        alignment="image-right"
    />
);

export default ImpulseSection;
